'use client';

import * as Card from '../../components/styled/card';
import { VStack, Box } from '@terra/ui-styled-system';
import { Skeleton } from '../../components/skeleton';
import { Children, Fragment, type ReactNode } from 'react';

export type SettingsCardProps = {
  children: ReactNode;
  footer?: ReactNode;
  isLoading?: boolean;
};

export function SettingsCard({
  children,
  footer,
  isLoading,
}: SettingsCardProps) {
  const contentItems = Children.toArray(children);

  return (
    <Card.Root
      w="full"
      bg="bg.neutral.default"
      borderWidth="1px"
      borderColor="border.neutral.subtle"
      borderRadius="lg"
      shadow="none"
      overflow="hidden"
      p={4}
    >
      <VStack alignItems="stretch" gap={3} w="full" overflow="hidden">
        {isLoading ? (
          <Box>
            <Skeleton h="120px" w="full" />
          </Box>
        ) : (
          contentItems.map((child, index) => (
            <Fragment key={index}>
              {child}
              {index < contentItems.length - 1 ? (
                <Box h="1px" w="full" bg="border.neutral.default" />
              ) : null}
            </Fragment>
          ))
        )}
        {footer ? (
          <Box
            pt={3}
            borderTopWidth="1px"
            borderTopColor="border.neutral.default"
          >
            {footer}
          </Box>
        ) : null}
      </VStack>
    </Card.Root>
  );
}
